export default {
    urlAPI: 'http://146.164.5.73:30180/im.ufrj.br/formulario-alumni/backend/public/api/',
    urlSite: 'http://146.164.5.73:30180/im.ufrj.br/formulario-alumni/site/public/api/',
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.js
// module id = 34
// module chunks = 6